import { Svg } from '@react-pdf/renderer';
import { type LucideIcon } from 'lucide-react';
import { type ReactElement } from 'react';
import { px } from '../../styles';
import { LUCIDE_ICON_NODES, renderLucideNode } from './utils';

interface LucidePdfIconProps {
  icon: LucideIcon;
  size: number;
}

export const LucidePdfIcon = ({ icon, size }: LucidePdfIconProps): ReactElement | null => {
  const iconNode = LUCIDE_ICON_NODES.get(icon);
  if (!iconNode) return null;

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      {iconNode.map(renderLucideNode)}
    </Svg>
  );
};

export const PDF_ICON_SIZE = {
  lg: px(24),
  sm: px(16),
} as const;
